import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
	auth: {
		clientId: window._env_.REACT_APP_AD_CLIENTID,
		authority: window._env_.REACT_APP_AD_AUTHORITY,
		redirectUri: "/signin-entra",
		postLogoutRedirectUri: "/"
	}
};

export const loginRequest: RedirectRequest = {
	scopes: [window._env_.REACT_APP_AD_SCOPE]
};
